import { Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { DeliverablesService } from '../../../../ve.service';
import { DataGridTemplate } from '../../../../../../shared/data-grid/data-grid.template';
import { UntypedFormGroup } from '@angular/forms';

export class BodyDeliverablesGridTemplate extends DataGridTemplate {
  editForm: UntypedFormGroup;
  workOrdersService: WorkOrdersService;
  deliverablesService: DeliverablesService;
  columns: any[];

  constructor(
    injector: Injector
  ) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.deliverablesService = injector.get(DeliverablesService);
    this.editForm = this.workOrdersService.bodyAddMultipleForm;
    this.setControls();
    this.setColumns();
    this.columnMenu = false;
    this.selectableSettings.enabled = true;
    this.pageable = false;
    this.gridState.take = null;
  }

  read(opts: any): Promise<any> {
    return this.deliverablesService.read('/includedInTemplate');
  }

  create(parentEditDataItem: any): void { 
    //this is kept empty on purpose
  }

  edit(dataItem: any): void { 
    //this is kept empty on purpose 
  }

  delete(dataItem: any): Promise<any> { return null; }

  save(dataItem: any, isNew: boolean): Promise<any> { return null; }

  private setColumns() {
    this.columns = [
      {
        field: 'Description',
        title: 'Deliverable'
      },
    ];
  }

  private setControls() {
    this.controls.excel = false;
    this.controls.delete = false;
    this.controls.edit = false;
    this.controls.add = false;
  }
}
